import { css } from '@emotion/react';
import { theme } from 'global';

export const appbar = (bottomBorder) => css`
  background-color: ${theme.colors.white};
  border-bottom: ${bottomBorder
    ? `1px solid ${theme.colors.neutral[200]}`
    : 'none'};
  height: var(--header-height);

  @media screen and (max-width: ${theme.breaks.xs}px) {
    border-bottom: none;
  }
`;

export const toolbar = css`
  padding: 8px 16px !important;
  min-height: var(--header-height) !important;

  @media screen and (max-width: ${theme.breaks.sm}px) {
    padding: 12px 16px !important;
  }
`;

export const logo = (isCenter) => css`
  user-select: none;
  margin-top: ${isCenter ? '-5px' : '0px'};
`;

export const helpButton = css`
  width: 94px;
  height: 38px;
  border-radius: 30px;
  padding: 4px 8px;
  margin-left: 12px;
  color: ${theme.colors.neutral[600]};
  background-color: ${theme.colors.neutral[0]};

  & > div {
    display: flex;
    column-gap: 6px;

    & > svg {
      background-color: ${theme.colors.electric};
      padding: 4px;
      border-radius: 30px;
      &:hover {
        color: ${theme.colors.secondary};
      }
    }

    & > span {
      align-content: center;
      font-weight: 500;
    }
  }

  &:hover {
    color: ${theme.colors.secondary};
  }

  @media screen and (max-width: ${theme.breaks.md}px) {
    order: 1;
    margin-left: 12px;
  }
`;

export const logoButton = css`
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;

  &:focus-visible {
    outline: 2px solid ${theme.colors.primary.main};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const closeButton = css`
  width: 20px;
  height: 20px;
  min-width: 20px;
  border: 0;
  padding: 0;
  margin-left: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: ${theme.colors.neutral[600]};
  cursor: pointer;

  &:hover {
    color: ${theme.colors.secondary};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.primary.main};
    outline-offset: 2px;
  }
`;
